import { Component, Inject, Input, OnDestroy, Optional } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';

import * as fromFooterLinks from '../../store';
import { LEGAL_PAGES } from '~app/modules/generic/constants/footer-links.constants';
import { isAccountTier3, isSubsidiary, UserInfoState } from '~shared/modules/user-info/store';
import { LegalRoute } from '~shared/models/legal-route.model';
import { MediaObserver } from '@angular/flex-layout';
import { takeUntil } from 'rxjs/operators';
import { NavigationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationNavigationEventType } from '~shared/modules/application-event/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { ACCESSIBILITY_FOOTER_LINK, GLOBAL_FOOTER_LINKS } from '../../constants';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { VAT_NUMBERS } from '~shared/constants/vat-number.constant';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { IS_COMPANION } from '~app/app.module';

@Component({
  selector: 'app-generic-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnDestroy {
  @Input() loadFooter: boolean;
  isMobile: boolean;
  destroySubject = new Subject();
  legalLinks: LegalRoute[];
  accessibilityLink: LegalRoute;
  isTier3$: Observable<boolean>;
  isSubsidiaryAccount$: Observable<boolean>;
  legalPagesType = LEGAL_PAGES;
  marketVatNo: string;

  constructor(
    private mediaObserver: MediaObserver,
    private applicationEventService: ApplicationEventService,
    private store: Store<fromFooterLinks.BuyerState | UserInfoState>,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any,
    @Optional() @Inject(IS_COMPANION) public isMMCompanion
  ) {
    const market = getCountryDomainCode(this.webAppBuyerRequest);
    this.isTier3$ = this.store.pipe(select(isAccountTier3));
    this.isSubsidiaryAccount$ = this.store.pipe(select(isSubsidiary));
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.destroySubject))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
      });
    this.legalLinks = GLOBAL_FOOTER_LINKS[market];
    this.accessibilityLink = ACCESSIBILITY_FOOTER_LINK;
    this.marketVatNo = VAT_NUMBERS[market];
  }

  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  handleGlobalFooterClickTracking(trackingLabel: string) {
    this.applicationEventService.publish(
      new NavigationApplicationEvent(ApplicationNavigationEventType.GlobalFooterClick, trackingLabel)
    );
  }
}
